import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/24.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Powrót do Tarszewa"
            question="A więc to on. Co robisz?"
            audio={audio}
            answers={{
                ans1: "Zsiadasz z wozu, żeby zagadać do starego Tornaua.",
                ans2: "Podążasz ukradkiem za starym Tornauem.",
                ans3: "Dopytujesz Emila o tajemniczą postać."
            }}
            links={{
                link1: PAGES.p39,
                link2: PAGES.p40,
                link3: PAGES.p41
            }}
            content={
                <div>
                    <p>
                        Hornowie wchodzą do chaty. Ty i Emil zostawiacie kosze ze śliwkami na podwórku, a w zamian ładujecie na wóz kosz ryb.
                    </p>
                    <ul>
                        <li>Garfunkelowie nas nie zaprosili na wesele, ale i tak skorzystaliśmy! – cieszy się Emil.
                            Wracacie tą samą drogą co wczoraj, a niebo zasnuwa się chmurami. Czy to mgła, czy znowu masz wrażenie, że ktoś przemyka się między brzozami nad rzeczką?
                        </li>
                        <li>Kto to jest? – pytasz Emila. Emil patrzy przez ramię i drapie się po głowie.</li>
                        <li>To stary Tornau. Czasem wołają go Samotny Olęder.</li>
                    </ul>
                </div>
            }
        />

    );
}